import { render } from "./App.vue?vue&type=template&id=1a1bf1e3&ts=true"
import script from "./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/src/PortalSite/Portal/ClientApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"views/Home/Index/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a1bf1e3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a1bf1e3', __exports__)) {
    api.reload('1a1bf1e3', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=1a1bf1e3&ts=true", () => {
    api.rerender('1a1bf1e3', render)
  })

}


export default __exports__